var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:send-fill",
    clipPath: "url(#clip0_969_3190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.235 5.6856C20.667 4.4906 19.509 3.3326 18.314 3.7656L3.709 9.0476C2.51 9.4816 2.365 11.1176 3.468 11.7566L8.13 14.4556L12.293 10.2926C12.4816 10.1104 12.7342 10.0096 12.9964 10.0119C13.2586 10.0142 13.5094 10.1194 13.6948 10.3048C13.8802 10.4902 13.9854 10.741 13.9877 11.0032C13.9899 11.2654 13.8892 11.518 13.707 11.7066L9.544 15.8696L12.244 20.5316C12.882 21.6346 14.518 21.4886 14.952 20.2906L20.235 5.6856Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_969_3190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.343bcb297c95661b8bcbbdbd0a364c8a.svg";
export { ForwardRef as ReactComponent };